import { TabsContent } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { PenLine } from "lucide-react";
import Template1 from "../card/c2ccard/tempate1";
import Template2 from "../card/c2ccard/template2";
import Template3 from "../card/c2ccard/template3";
import Template4 from "../card/c2ccard/template4";
import TemplateCardSkeleton from "@/components/skeleton/template-card-skeleton";
import { getTemplateBySerial } from "@/lib/loyalty-template-utils";

const cards = [
  { title: "C2C Gift Card Template 1", Component: Template1 },
  { title: "C2C Gift Card Template 2", Component: Template2 },
  { title: "C2C Gift Card Template 3", Component: Template3 },
  { title: "C2C Gift Card Template 4", Component: Template4 },
];

function C2cGiftCard({ templates = [], getLoading = false, onOpenCreate, onOpenEdit }) {

  return (
    <TabsContent value="c2c_voucher">
      {getLoading ? <TemplateCardSkeleton /> : null}
      {!getLoading ? (
      <div className="mt-6 grid  lg:grid-cols-2 gap-6">
        {cards.map(({ title, Component }, index) => {
          const template = getTemplateBySerial(templates, index + 1);

          return (
            <Card key={title}>
              <CardHeader className="pb-2">
                <div className="flex justify-between items-center">
                  <h3 className="text-base">{template?.title || title}</h3>
                  <div className="p-1.5 bg-cblack7 rounded-full">
                    <PenLine
                      className="w-4 h-4 cursor-pointer hover:text-white transition-all duration-300 text-muted-foreground"
                      onClick={() => onOpenEdit(template)}
                    />
                  </div>
                </div>
              </CardHeader>
              <CardContent className="pb-4 mt-4">
                <Component template={template} />
              </CardContent>
            </Card>
          );
        })}
      </div>
      ) : null}
    </TabsContent>
  );
}

export default C2cGiftCard;
